function FollowUs(){
    return (
            <section className="py-5 my-md-5">
                <div className="container">
                <div className="row justify-content-center text-center">
                    <div className="col-lg-8">
                    <span className="text-muted">Newsletter</span>
                    <h2 className="display-5 fw-bold">Unlock the Power of Open Source!</h2>
                    <p className="lead">
                        Subscribe today and gain access to a cutting-edge service built with the best open-source tools.
                    </p>
                </div>
                </div>
                <div className="row justify-content-center text-center">
                    <div className="col-lg-6">
                    <div className="mx-auto">
                        <form className="row g-3 justify-content-center">
                        <div className="col-md-6">
                            <input
                            className="form-control bg-light"
                            placeholder="First name"
                            type="text"
                            />
                        </div>
                        <div className="col-md-6">
                            <input
                            className="form-control bg-light"
                            placeholder="Last name"
                            type="text"
                            />
                        </div>
                        <div className="col-md-12">
                            <input
                            className="form-control bg-light"
                            placeholder="Email address"
                            type="text"
                            />
                        </div>
                        <div className="col-md-5">
                            <div className="d-grid mx-auto">
                            <button className="btn btn-primary" type="submit">
                                Subscribe
                            </button>
                            </div>
                        </div>
                        </form>
                    </div>
                    </div>
                </div>
                </div>
            </section>
    )
}

export default FollowUs